import styled from "styled-components";

export const ResueltasTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #f2f2f7;
  box-sizing: border-box;
  padding: 0 20px;
  .table-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    padding: 20px 30px;
    border-bottom: 1px solid #cfd3dd;

    .th-item {
      font-size: 14px;
      color: #707582;
    }
    .th-actions {
      text-align: right;
    }
  }

  .table-body {
    flex: 1;
    overflow-y: auto;

    .table-row {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
      align-items: center;
      padding: 16px 0;
      border-bottom: 1px solid #cfd3dd;

      .col-patient {
        display: flex;
        align-items: center;
        gap: 16px;

        .avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          object-fit: cover;
          background: #ccc;
        }

        .info-group {
          display: flex;
          flex-direction: column;

          .phase {
            font-size: 12px;
            color: #707582;
          }
          .name {
            font-size: 17px;
            color: #1f1f52;
            font-family: "Nunito Sans Bold";
          }
          .barrier {
            font-size: 17px;
            color: #707582;
          }
        }
      }

      .col-date-rep {
        font-size: 14px;
        color: #707582;
      }

      .col-date-exp {
        font-size: 12px;
        color: #1f1f52;
        display: flex;
        align-items: center;
        gap: 6px;
        .icon-date {
          font-size: 11px;
          &.delayed {
            color: #e6575e;
          }
          &.ontime {
            color: #1f1f52;
          }
        }
      }

      .col-date-res {
        font-size: 14px;
        color: #707582;
      }

      .col-actions {
        text-align: right;
        justify-items: end;
        .ver-reporte {
          width: 150px;
        }
      }
    }
  }

  .eso-es-todo {
    text-align: center;
    padding: 20px;
    font-size: 15px;
    color: #4a5568;
  }
`;
